import React from 'react';
import styled from 'styled-components';

import {labels} from '../../../../util/utils';

import {IconoirUser} from '@ey-xd/motif-icon';

import Button from '../../../CoreWrappers/Button';
import User from '../../../CoreWrappers/User';

const UserDrydock = () => {
	const renderFound = (showInfo = true, showPresence = false) => {
		const props = {
			email: 'fernando.surenian@ey.com',
			firstName: 'Fernando',
			lastName: 'Surenian',
			isInternal: true,
			showType: true,
			showInfo,
			showPresence,
			renderExtra: () => {
				const props = {
					svg: IconoirUser,
					title: labels.userProfile,
					onClick: () => null,
					variant: 'text',
					iconSize: 20
				};

				return <Button {...props} />;
			}
		};

		return <User {...props} />;
	};

	const renderNotFound = (firstName = 'Jhon', lastName = 'Doe') => {
		const props = {
			firstName,
			lastName
		};

		return <User {...props} />;
	};

	const renderInternal = () => {
		const props = {
			firstName: 'Internal',
			lastName: 'User',
			isInternal: true,
			showType: true
		};

		return <User {...props} />;
	};

	const renderExternal = (firstName = 'Jhon', lastName = 'Doe') => {
		const props = {
			firstName: 'External',
			lastName: 'User',
			isInternal: false,
			showType: true
		};

		return <User {...props} />;
	};

	return (
		<>
			{renderFound()}
			{renderFound(false, true)}
			{renderNotFound()}
			{renderNotFound(null)}
			{renderNotFound('Some Large Name User', 'Some Large Last Name User')}
			{renderInternal()}
			{renderExternal()}
		</>
	);
};

export default UserDrydock;
